module.exports = {

  init() {

    lozad().observe();
  	
  	this.search();
  	
  	this.takeway();
  	
  	this.owl();
  	
  	this.nav();

  },
  
  search: function() {
    
    jQuery('.search-link a').click(function(event)
      { 
        event.preventDefault();
        jQuery('.search-bar').slideDown('fast');
        $(".search-bar input[type=search]").focus();
        
      }
    );
    
    jQuery('.search-bar .close').click(function(event)
      { 
        event.preventDefault();
        jQuery('.search-bar').slideUp('fast');
        
      }
    );
    
  },

  takeway: function() {
  
    jQuery('.takeway').click(function()
    	{
  	    jQuery('body').toggleClass('menu-open');
  	    if (jQuery('body').hasClass('menu-open'))
  	    {
  	    	jQuery('.nav').slideDown();
  	    } 
  	    else
  	    {
  	      jQuery('.nav').slideUp();
  	    }
      }
    );

  },
  
  owl: function() {
  	
  	jQuery('.slider').owlCarousel({
  	    autoplay: false,
  	    loop:true,
  	    margin:0,
  	    nav:true,
  	    items: 1,
  	    navText: [,],
  	    autoHeight:true
  	});
  	
  	
  	jQuery('.minicarousel').owlCarousel({
  	    loop:true,
  	    margin:0,
  	    nav:true,
  	    items: 1,
  	    navText: [,],
  	    autoHeight:true
  	});
  
  },
  
  
  nav: function() {
	
  	jQuery("nav .menu-item-has-children ").append("<div class='menuarrow'></div>");
  	jQuery(".menuarrow").click(function() {
  		jQuery(this).parent().children('ul .sub-menu').slideToggle();
  		jQuery(this).toggleClass('up');
  	});
  	
  	
  	function is_touch_device() {
  	  return !!('ontouchstart' in window);
  	}
  	
  	
  	
  	function myfunction() {
  				
  		if(is_touch_device()) {				
  			var windowWidth = jQuery(window).width();
  			jQuery('.menu-item-has-children > a').unbind();
  				jQuery('.menu-item-has-children > a').click(function(event) {
  					if (windowWidth > 1160){
  						event.preventDefault();
  						jQuery(this).unbind( event );   
  					}
  			});
  		}
  		
  		var maxHeight = 0;
	  
		  if ($(window).width() > 1160) {
  		  
  		  $("#menu-main-menu > li  ul.sub-menu ").each(function(){
    			var count = $(this).children('li').length;
    			
    			if(count > 5){
      			$(this).addClass('two-column');
    			}
    			
  			});
      	
      	$("#menu-main-menu > li > ul.sub-menu").each(function(){

        	var count = $(this).children('li.menu-item-has-children').length;
        	
      	  if(count > 1){

          	for(var i = 1; i <= count; i++ ){

            	var thisHeight = $(this).find('li.menu-item-has-children:nth-child('+i+') ul.sub-menu');
            	var thisH = thisHeight.height();

            	if (thisH > maxHeight) { maxHeight = thisH; }
          	}
      			
      			$(this).css('min-height', maxHeight + 32);
      			$(this).find(".sub-menu").css('min-height', maxHeight + 32);
      		}
   
  			});
  			
  			
  			
  			
  			
			
		  } else{
			  $(".sub-menu").css('min-height', 0);
			  $(".sub-menu").removeClass('two-column');
		  }
  		
  		
  	}
  	jQuery(document).ready(myfunction);
  	jQuery(window).on('resize',myfunction);
  
  },
  
  
  
}